"use strict";

/* istanbul ignore file */
var React = require("react");
var createContext = React.createContext,
  useContext = React.useContext;
var Storage = require("../Storage");

// TODO: ---->This does not allow adapter injection<---
var storage = new Storage();
var StorageContext = createContext();
var StorageProvider = function StorageProvider(_ref) {
  var children = _ref.children,
    userId = _ref.userId;
  return /*#__PURE__*/React.createElement(StorageContext.Provider, {
    value: {
      userId: userId
    }
  }, children);
};
var useStorageContext = function useStorageContext() {
  var userId = useContext(StorageContext);
  return userId;
};
module.exports = {
  StorageProvider: StorageProvider,
  useStorageContext: useStorageContext,
  storage: storage
};